import { Component, Input } from '@angular/core';
import { Deadicionales } from '../../../shared/models/static-model/suppliers.model';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { GeneralService } from '../../../shared/services/general.service';
import { InputGeneralSelectComponent } from '../../../shared/inputs/input-general-select/input-general-select.component';
import { InputGeneral } from '../../../shared/inputs/input-general/input-general';
import { InputGeneralCalendarComponent } from '../../../shared/inputs/input-general-calendar/input-general-calendar.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-capture-data-suppliers',
  templateUrl: './capture-data-suppliers.component.html',
  imports: [InputGeneralSelectComponent, InputGeneral, InputGeneralCalendarComponent, TranslateModule],
})
export class CaptureDataSuppliersComponent {
  @Input() quotationId: number | null = null;
  public deadicionales: Deadicionales[] = [];
  public proveedores: any[] = [];

  constructor(
    private staticPageService: StaticPageService,
    private generalService: GeneralService,
  ) {}

  ngOnInit(): void {
    this.getDeadicionales();
    this.getProveedores();
  }

  private getDeadicionales(): void {
    this.staticPageService.getDeadicionales(this.quotationId ?? 0).subscribe((ress) => {
      if (ress) {
        this.deadicionales = ress;
      }
    });
  }

  private getProveedores(): void {
    this.staticPageService.getProveedores().subscribe((ress) => {
      if (ress) {
        this.proveedores = ress;
      }
    });
  }
}
